module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_number_08-8bfbab763b9f981b59003d7e5cb8eec6.svg";